import {createApp} from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faAngleDown, faAngleUp, faSearch,} from "@fortawesome/free-solid-svg-icons";

import App from "@/App.vue";
import "@/assets/tailwind.css";
import router from "@/router";
import store, {key} from "@/store";
import {BrowserTracing} from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
import getApiDomain from "@/api/getApiDomain";

library.add(faSearch);
library.add(faAngleUp);
library.add(faAngleDown);

// Global error handler for chunk loading failures (CSS and JS chunks)
window.addEventListener('error', (event) => {
	const target = event.target as HTMLElement;
	const isChunkLoadError =
		(target.tagName === 'LINK' && (target as HTMLLinkElement).rel === 'stylesheet') ||
		(target.tagName === 'SCRIPT');

	if (isChunkLoadError) {
		const hasReloaded = sessionStorage.getItem('chunk-load-failed');

		if (!hasReloaded) {
			sessionStorage.setItem('chunk-load-failed', 'true');
			console.log('Chunk load error detected, reloading page...');
			window.location.reload();
		} else {
			sessionStorage.removeItem('chunk-load-failed');
			console.error('Chunk loading failed even after reload:', event);
		}
	}
}, true);

const app = createApp(App);

if (getApiDomain().includes("https")) {
	Sentry.init({
		app,
		dsn: "https://847d100b228f414aae51ab4b7840d011@sentry02.allbytes.net/22",
		integrations: [
			new BrowserTracing({
				routingInstrumentation: Sentry.vueRouterInstrumentation(router),
				tracingOrigins: [
					"localhost",
					"localhost:8080",
					"sentry02.allbytes.net",
					"payjet-kundenportal.allbytes.run",
					"payjet-kundenportal-staging.allbytes.run",
					/^\//
				],
			}),
		],
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
	});
}


app.use(store, key)
app.use(router)
app.component("font-awesome-icon", FontAwesomeIcon)
app.mount("#app");

// Clear the chunk-load-failed flag on successful app start
router.isReady().then(() => {
	sessionStorage.removeItem('chunk-load-failed');
});
